import useInView from '../../../hooks/useInView';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const VisionSection = () => {
  const image = "/assets/imgs/About/Inner Pages_Picture_About_2.png";
  const [ref, inView] = useInView({ threshold: 0.15 });
  const { t } = useTranslation('common');

  return (
    <section ref={ref} className="bg-cream py-16 lg:py-24">
      <div className="container mx-auto px-8 lg:px-16">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left - Text */}
          <div className={`transition-all duration-700 ease-out ${inView ? 'opacity-100 -translate-x-0' : 'opacity-0 -translate-x-6'}`}>
            <h2 className="text-5xl lg:text-6xl font-bold text-text-dark mb-6">{t('about.dearParents.title')}</h2>
            <p className="text-base text-text-dark leading-relaxed mb-4 max-w-xl">{t('about.dearParents.p1')}</p>
            <p className="text-base text-text-dark leading-relaxed mb-8 max-w-xl">{t('about.dearParents.p2')}</p>
            <Link to="/shop" className="inline-block bg-brown hover:bg-brown-dark text-cream px-8 py-3 rounded text-sm font-normal uppercase tracking-wide transition-all duration-300">
              {t('about.shopNow')}
            </Link>
          </div>

          {/* Right - Single Image */}
          <div className={`group w-full overflow-hidden rounded-lg shadow-md transition-all duration-700 ease-out ${inView ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
            <img 
              src={image} 
              alt={t('about.visionAlt')} 
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionSection;
